import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const list: Readonly<Array<ItemVM>> = Object.freeze([
  {
    id: '0',
    value: 'Non richiesto',
  },
  {
    id: '1',
    value: 'Richiesto',
  },
]);

interface CfControlListProps {
  value: string;
  disabled?: boolean;
  error?: boolean;
  onChange: (control: string) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

const CfControlListComponent = ({
  value,
  disabled,
  onChange,
  error,
  required,
  label = 'Controllo dati AE',
  id = 'cf-control-list',
}: CfControlListProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={idTag}>{required ? `${label} *` : label || undefined}</InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        error={error}
        label={required ? `${label} *` : label || undefined}
        disabled={disabled}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {list.map((control: ItemVM) => (
          <MenuItem key={control.id} value={control.id}>
            {control.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CfControlListComponent.displayName = 'Fiscal code control list component';

export const CfControlList = memo(CfControlListComponent) as typeof CfControlListComponent;

export default CfControlList;
